import { useState } from "react";

import {
  glassList36H,
  glassList42H,
  glassList48H,
  glassList48R,
  glassListOtherR,
} from "data/products/glassPanels";
import { Pannel, Province } from "types/canvasTypes";

type HeightGroup = {
  label: string;
  key: string;
  panels: Pannel[];
};

const heightGroups: HeightGroup[] = [
  { label: '36"', key: "36", panels: glassList36H },
  { label: '42"', key: "42", panels: glassList42H },
  { label: '48"', key: "48", panels: glassList48H },
  { label: '48" R-Panel', key: "48r", panels: glassList48R },
  { label: "Other R-Panel", key: "other", panels: glassListOtherR },
];

const extractVariantId = (gid: string | undefined) => {
  if (!gid) return "---";
  return gid.split("/").pop() || gid;
};

const AdminGlassPanels = () => {
  const [activeTab, setActiveTab] = useState("36");

  const activeGroup = heightGroups.find((g) => g.key === activeTab)!;

  return (
    <div>
      <div className="admin-page-header">
        <div className="admin-page-header__left">
          <h1>Glass Panels</h1>
          <span className="admin-badge">{activeGroup.panels.length}</span>
        </div>
      </div>

      <div className="admin-tabs">
        {heightGroups.map((group) => (
          <button
            key={group.key}
            className={`admin-tab${activeTab === group.key ? " admin-tab--active" : ""}`}
            onClick={() => setActiveTab(group.key)}
          >
            {group.label}
            <span className="admin-tab__count">{group.panels.length}</span>
          </button>
        ))}
      </div>

      <div className="admin-table-wrap">
        <table className="quotation-table">
          <thead>
            <tr>
              <th>Length (in)</th>
              <th>QC Price</th>
              <th>ON Price</th>
              <th>BC Variant</th>
              <th>GR Variant</th>
              <th>RF Variant</th>
            </tr>
          </thead>
          <tbody>
            {activeGroup.panels.map((panel, i) => (
              <tr key={i}>
                <td>
                  <strong>{panel.length}"</strong>
                </td>
                <td>${panel.price.get(Province.Quebec) ?? "---"}</td>
                <td>${panel.price.get(Province.Ontario) ?? "---"}</td>
                <td className="admin-cell-mono">
                  {extractVariantId(panel.bcVariantId)}
                </td>
                <td className="admin-cell-mono">
                  {extractVariantId(panel.grVariantId)}
                </td>
                <td className="admin-cell-mono">
                  {extractVariantId(panel.rfVariantId)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminGlassPanels;
